import { PaginatedResponse } from '@gorila-shared-ui/components';
import { atom, selector, selectorFamily } from 'recoil';
import { FENCE_TYPE_ENTRY } from '../constants/fences';
import { Fence, FenceCore } from '../types/fence';
import { apiParamsState } from './app';

export const loadingFencesState = atom({
  key: 'app.client.fences.loading',
  default: false,
});

export const fencesState = atom<PaginatedResponse<Fence> | undefined>({
  key: 'app.client.fences',
  default: undefined,
});

export const fenceIdsState = selector<string[] | undefined>({
  key: 'app.client.fenceIds',
  get: ({ get }) => {
    const fences = get(fencesState);
    if (!fences) return;
    return fences.items.map((fence) => fence._id);
  },
});

export const fenceState = selectorFamily<Fence | undefined, string>({
  key: 'app.client.fence',
  get:
    (id) =>
    ({ get }) => {
      const fences = get(fencesState);
      if (!fences?.items) return;
      return fences.items.find((fence) => fence._id === id);
    },
});

export const selectedFenceIdState = atom<string | undefined>({
  key: 'app.client.fences.selectedId',
  default: undefined,
});

export const searchFenceState = atom<string | undefined>({
  key: 'app.client.fences.search',
  default: undefined,
});

export const fencesPageState = atom({
  key: 'app.client.fences.page',
  default: 1,
});

export const selectedFenceState = atom<FenceCore | undefined>({
  key: 'app.client.fences.selected',
  default: undefined,
});

export const editingFenceState = atom<FenceCore | undefined>({
  key: 'app.client.fences.editing',
  default: selector({
    key: 'app.client.fences.editing.initializer',
    get: ({ get }) => {
      const selectedFenceId = get(selectedFenceIdState);
      if (selectedFenceId === undefined) return;
      if (selectedFenceId === '') {
        const apiParams = get(apiParamsState);
        if (!apiParams) return;
        return {
          _id: '',
          client: apiParams.clientId,
          subClient: apiParams.subClientId,
          active: true,
          startDate: null,
          endDate: null,
          fenceType: FENCE_TYPE_ENTRY,
          indeterminate: true,
          name: '',
          assignedAssets: [],
        };
      }
      return get(fenceState(selectedFenceId));
    },
  }),
});

export const updateFencesState = atom<string | undefined>({
  key: 'app.client.fences.update',
  default: undefined,
});
